<app-header></app-header>
<ion-content>
  <ng-container
    *ngIf="(this.platformService?.isTouchExperience$ | async) === false"
  >
    <ion-grid>
      <ion-row>
        <ion-col>
          <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
        </ion-col>
      </ion-row>
      <ion-row>
        <div class="header-section">
          <h1 data-cy="quick-order-entry-page-title">
            {{'i18n.quickOrderEntryPage.quickOrderPageTitle' | translate}}
          </h1>
          <ng-container *appShowSplit="[qoeToggleFeatureFlag]">
            <ion-segment
              data-cy="qoe-segment-product-type-toggle"
              class="qoe-type-toggle"
              mode="ios"
              [(ngModel)]="selectProductTypeTab"
              (ionChange)="toggleChange()"
            >
              <ion-segment-button
                data-cy="qoe-segment-product-num-toggle-button"
                [value]="toggleBtnProductNum"
              >
                <ion-label data-cy="qoe-segment-product-num-toggle-text">
                  {{ 'i18n.quickOrderEntryPage.productNum' | translate }}
                </ion-label>
              </ion-segment-button>
              <ion-segment-button
                data-cy="qoe-segment-product-cust-toggle-button"
                [value]="toggleBtnProductCustNum"
              >
                <ion-label data-cy="qoe-segment-product-cust-toggle-text">
                  {{'i18n.quickOrderEntryPage.custProductNum' | translate}}
                </ion-label>
              </ion-segment-button>
            </ion-segment>
          </ng-container>
        </div>
      </ion-row>
      <ion-row>
        <ion-col size-lg="9">
          <ion-row>
            <div class="qoe-product-row">
              <div class="container">
                <div class="qoe-product-number">
                  <div
                    class="medium-font-weight sort-label"
                    *ngIf="selectProductTypeTab === toggleBtnProductNum; else custProduct"
                  >
                    {{'i18n.quickOrderEntryPage.productNum' | translate}}
                  </div>
                  <ng-template #custProduct>
                    <div class="medium-font-weight">
                      {{'i18n.quickOrderEntryPage.custProdNum' | translate}}
                    </div>
                  </ng-template>
                </div>
                <div class="qoe-product-quantity">
                  <div class="medium-font-weight sort-label">
                    {{'i18n.quickOrderEntryPage.quantity' | translate}}
                  </div>
                </div>
                <div class="qoe-product-description">
                  <div class="medium-font-weight sort-label">
                    {{'i18n.quickOrderEntryPage.productDesc' | translate}}
                  </div>
                </div>
                <div class="qoe-product-price">
                  <div class="medium-font-weight sort-label">
                    {{'i18n.quickOrderEntryPage.price' | translate}}
                  </div>
                </div>
              </div>
            </div>
          </ion-row>
          <app-quick-order-entry-row-desktop
            *ngFor="let qoi of quickOrderItems$ | async; index as i"
            id="qoi-{{i}}"
            [qoi]="qoi"
            [toggleSelection]="selectProductTypeTab"
            (search)="qoeProductSearch( i , $event )"
            (quantity)="qoeProductUpdate( i , $event )"
            (hotkey)="changeFocus( i , $event )"
            [isOnline]="(panAppState.online$ | async)"
            (forceFocus)="overrideFocus( i , $event )"
          >
          </app-quick-order-entry-row-desktop>
          <a
            class="medium-font-weight green-link"
            data-cy="quick-order-entry-add-rows-link"
            (click)="addMoreRows(100)"
          >
            {{'i18n.quickOrderEntryPage.addLgRows' | translate}}
            <ion-icon name="add"></ion-icon>
          </a>
        </ion-col>
        <ion-col size-lg="3">
          <div
            *ngIf="!!(quickOrderItems$ | async)?.length"
            class="order-info-qoe-sidebar"
          >
            <app-order-info-sidebar
              *ngIf="!!vm; else emptySidebar"
              [platform]="platformService?.platformType"
              [orderHeader]="vm?.orderHeader"
              [orderItemTallies]="vm?.orderTallies"
              [isList]="false"
              [isCart]="false"
              [isOnMinimumOrderMetFlag]="isOnMinimumOrderMetFlag"
            ></app-order-info-sidebar>
            <ng-template #emptySidebar>
              <app-order-info-sidebar
                [platform]="platformService?.platformType"
                [isList]="false"
                [isCart]="false"
                [isOnMinimumOrderMetFlag]="isOnMinimumOrderMetFlag"
              ></app-order-info-sidebar>
            </ng-template>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
    <app-footer></app-footer>
  </ng-container>

  <!-- TOUCH -->
  <ng-container
    *ngIf="(this.platformService?.isTouchExperience$ | async) === true"
  >
    <ion-grid>
      <ion-row>
        <h1
          *ngIf="platformService?.platformType !== platformService?.platformEnum.mobile"
        >
          {{'i18n.quickOrderEntryPage.quickOrderPageTitle' | translate}}
        </h1>
      </ion-row>
      <ion-row>
        <ng-container *appShowSplit="[qoeToggleFeatureFlag]">
          <ion-segment
            data-cy="qoe-segment-product-type-toggle"
            class="qoe-type-toggle"
            mode="ios"
            [(ngModel)]="selectProductTypeTab"
            (ionChange)="toggleChange()"
          >
            <ion-segment-button
              data-cy="qoe-segment-product-num-toggle-button"
              [value]="toggleBtnProductNum"
            >
              <ion-label data-cy="qoe-segment-product-num-toggle-text">
                {{ 'i18n.quickOrderEntryPage.productNum' | translate }}
              </ion-label>
            </ion-segment-button>
            <ion-segment-button
              data-cy="qoe-segment-product-cust-toggle-button"
              [value]="toggleBtnProductCustNum"
            >
              <ion-label data-cy="qoe-segment-product-cust-toggle-text">
                {{'i18n.quickOrderEntryPage.custProductNum' | translate}}
              </ion-label>
            </ion-segment-button>
          </ion-segment>
        </ng-container>
      </ion-row>
      <ion-row>
        <ion-col>
          <ng-container
            *ngIf="platformService?.platformType !== platformService?.platformEnum.mobile"
          >
            <ion-row>
              <ion-col>
                <div class="sort-header">
                  <div class="sort-label-wrapper product-num-tablet">
                    <div
                      class="medium-font-weight sort-label"
                      *ngIf="selectProductTypeTab === toggleBtnProductNum; else custProduct"
                    >
                      {{'i18n.quickOrderEntryPage.productNum' | translate}}
                    </div>
                    <ng-template #custProduct>
                      <div class="medium-font-weigh sort-label">
                        {{'i18n.quickOrderEntryPage.customerProductNum' |
                        translate}}
                      </div>
                    </ng-template>
                    <div class="caret-icon">
                      <ion-icon name="caret-up-outline"></ion-icon>
                      <ion-icon name="caret-down-outline"></ion-icon>
                    </div>
                  </div>
                  <div class="sort-label-wrapper">
                    <div class="medium-font-weight sort-label">
                      {{'i18n.quickOrderEntryPage.quantity' | translate}}
                    </div>
                  </div>
                  <div class="sort-label-wrapper">
                    <div>&nbsp;</div>
                  </div>
                </div>
              </ion-col>
            </ion-row>
            <app-quick-order-entry-row-tablet
              *ngFor="let qoi of quickOrderItems$ | async; index as i"
              id="qoi-{{i}}"
              [qoi]="qoi"
              [toggleSelection]="selectProductTypeTab"
              (search)="qoeProductSearch( i , $event )"
              (quantity)="qoeProductUpdate( i , $event )"
              (hotkey)="changeFocus( i , $event )"
              [isOnline]="(panAppState.online$ | async)"
              (forceFocus)="overrideFocus( i , $event )"
            >
            </app-quick-order-entry-row-tablet>
            <a
              class="medium-font-weight green-link"
              data-cy="quick-order-entry-add-rows-link"
              (click)="addMoreRows(100)"
            >
              {{'i18n.quickOrderEntryPage.addLgRows' | translate}}
              <ion-icon name="add"></ion-icon>
            </a>
          </ng-container>
          <ng-container
            *ngIf="platformService?.platformType === platformService?.platformEnum.mobile"
          >
            <app-quick-order-entry-row-mobile
              *ngFor="let qoi of quickOrderItems$ | async; index as i"
              id="qoi-{{i}}"
              [qoi]="qoi"
              [toggleSelection]="selectProductTypeTab"
              (search)="qoeProductSearch( i , $event )"
              (quantity)="qoeProductUpdate( i , $event )"
              (hotkey)="changeFocus( i , $event )"
              [isOnline]="(panAppState.online$ | async)"
              (forceFocus)="overrideFocus( i , $event )"
            ></app-quick-order-entry-row-mobile>
            <a
              class="medium-font-weight green-link"
              data-cy="quick-order-entry-add-rows-link"
              (click)="addMoreRows(10)"
            >
              {{'i18n.quickOrderEntryPage.addSmRows' | translate}}
              <ion-icon name="add"></ion-icon>
            </a>
          </ng-container>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-container>
</ion-content>

<div data-cy="qoe-top-button-section" class="scroll-to-top-button">
  <ion-button
    data-cy="qoe-top-button"
    class="usf-fill-green-button"
    (click)="goToTop()"
  >
    {{ 'i18n.common.top' | translate }}&nbsp;
    <ion-icon data-cy="qoe-top-button-icon" name="chevron-up"></ion-icon>
  </ion-button>
</div>
